import axios from "axios";
import { get } from "lodash";
import { toastr } from "react-redux-toastr";
import { error, log } from "../../utils/logger";
import {
  UP_SELL_LOADING,
  SET_UP_SELL_COUNTS,
  RESET_REPORTS,
  ADD_REPORT_ERROR,
  SET_UP_SELL_TYPES,
  SET_UP_SELL_SUBTYPES,
} from "../constants";

export const UP_SELL_QUERY_TOKEN = "amrnUpSellOptions";

export const addError = (error, name) => (dispatch) => {
  dispatch({ type: ADD_REPORT_ERROR, payload: error, name });
};

// ============================================================================
// Get Options ================================================================
// ============================================================================

export const getTypeOptions = (options) => (dispatch) => {
  log(`Getting report typeOptions`);

  dispatch({ type: UP_SELL_LOADING, payload: "types" });

  return axios
    .post(`reports/up-sell/types`, options)
    .then((res) => {
      const payload = get(res, "data.types");

      payload && dispatch({ type: SET_UP_SELL_TYPES, payload });

      return payload;
    })
    .catch((err) => {
      error("Error getting types", err);
      toastr.error("Error", "There was a problem getting 'type' options. Please try again later");
      dispatch(addError(err, "types"));
    });
};

export const getSubTypeOptions = (options) => (dispatch) => {
  log(`Getting report subTypeOptions`);

  dispatch({ type: UP_SELL_LOADING, payload: "subTypes" });

  return axios
    .post(`reports/up-sell/sub-types`, options)
    .then((res) => {
      const payload = get(res, "data.sub_types");

      payload && dispatch({ type: SET_UP_SELL_SUBTYPES, payload });

      return payload;
    })
    .catch((err) => {
      error("Error getting sub-types", err);
      toastr.error(
        "Error",
        "There was a problem getting 'sub-type' options. Please try again later"
      );
      dispatch(addError(err, "subTypes"));
    });
};

// ============================================================================
// Get Data ===================================================================
// ============================================================================

export const getUpSellCounts = (options) => (dispatch) => {
  log(`Getting up-sell counts with options`, options);

  dispatch({ type: UP_SELL_LOADING, payload: "counts" });

  return axios
    .post(`reports/up-sell/counts`, options)
    .then((res) => {
      const payload = get(res, "data.counts");

      payload && dispatch({ type: SET_UP_SELL_COUNTS, payload });

      return payload;
    })
    .catch((err) => {
      error("Error getting mobile originated counts", err);
      dispatch(addError(err, "counts"));
    });
};

//reset landing reducer state
export const resetState = () => ({ type: RESET_REPORTS });
